function veda_fn_id_00beb217344d416abf30dd8276f9dd97() {
    
    try {
      const uniqueId = /* _____Start/Id_____ */"id_00beb217-344d-416a-bf30-dd8276f9dd97"/* _____End/Id_____ */;
      const containers = document.querySelectorAll(`[data-id="${uniqueId}"]:not(addons, megamenu)`);
      containers.forEach(container => {
        if (!container) {
          return;
        }
        veda.plugins.videoCover(container);
        /* _____Start/Content_____ */
        const { objectParse } = veda.utils;
const { cart, message } = veda.plugins;
const templateEle = container.querySelector("#sticky-template");
const template = objectParse(templateEle.textContent);
const templateProduct = template.template === "product";
const testing = container.getAttribute("data-testing");
const dataBottom = Number(container.getAttribute("data-bottom"));
const tabNavigatorEl = document.querySelector(
  'section[class*="veda-tab-navigator"]'
);
const hideOnMobile = container.getAttribute("data-visible-mobile") === "true";

function isMobile() {
  const mobileWidthThreshold = 768;
  return window.innerWidth < mobileWidthThreshold;
}

function handleHideOnMobile() {
  if (isMobile() && hideOnMobile) {
    container.style.display = "none";
  } else {
    container.style.display = "block";
  }
}

function handleChangeBottom() {
  if (
    tabNavigatorEl &&
    window.getComputedStyle(tabNavigatorEl).display !== "none"
  ) {
    const height = tabNavigatorEl.offsetHeight;
    let bottom = `${dataBottom + height}px`;
    if (isMobile()) {
      bottom = `${height + 5}px`;
    }
    container.style.bottom = bottom;
  } else {
    let bottom = `${dataBottom}px`;
    if (isMobile()) {
      bottom = `5px`;
    }
    container.style.bottom = bottom;
  }
}

function popupShow() {
  container.style.transform = "translateY(0)";
}

function popupHide() {
  if (
    tabNavigatorEl &&
    window.getComputedStyle(tabNavigatorEl).display !== "none"
  ) {
    const height = tabNavigatorEl.offsetHeight;
    container.style.transform = `translateY(calc(150% + ${
      dataBottom + height
    }px))`;
  } else {
    container.style.transform = `translateY(calc(150% + ${dataBottom}px))`;
  }
}

if (builderMode) {
  if (testing == "true") {
    popupShow();
  } else {
    popupHide();
  }
}

if (!!templateProduct) {
  const main = () => {
    let loading = false;

    function addCartSuccess(el) {
      const check = `
      <svg class="checkmark w:14px h:14px mr:10px bdrs:50% d:block stkw:2 stk:#fff stroke-miterlimit:10 bxsh:inset_0px_0px_0px_#7ac142 anim:fill_0.4s_ease-in-out_0.4s_forwards,scale_0.3s_ease-in-out_0.9s_both" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 52 52">
        <circle class='checkmark__circle sd:166 stroke-dasharray:166 stkw:2 stroke-miterlimit:10 stk:#7ac142 fill:none anim:stroke_0.6s_cubic-bezier(0.65,0,0.45,1)_forwards' cx='26' cy='26' r='25' fill='none'/> 
        <path class='checkmark__check trfo:50%_50% stroke-dasharray:48 sd::48 anim:stroke_0.3s_cubic-bezier(0.65,0,0.45,1)_0.8s_forwards' fill='none' d='M14.1 27.2l7.1 7.2 16.7-16.8'/>
      </svg>`;
      el.insertAdjacentHTML("afterbegin", check);
      setTimeout(() => {
        const checkEl = el.querySelector(".checkmark");
        if (!!checkEl) {
          checkEl.remove();
        }
        loading = false;
      }, 2000);
    }

    // show when scroll
    const dataScroll = Number(container.getAttribute("data-scroll"));

    if (dataScroll === 0) {
      popupShow();
    } else {
      popupHide();
    }

    const handleScroll = () => {
      let visible = false;
      const scrollPercentage =
        (window.scrollY /
          (document.documentElement.scrollHeight - window.innerHeight)) *
        100;

      if (scrollPercentage >= dataScroll) {
        visible = true;
      } else {
        visible = false;
      }
      if (window.scrollY === 0 && dataScroll !== 0) {
        visible = false;
      }
      if (scrollPercentage >= 100) {
        visible = false;
      }

      if (!!visible) {
        popupShow();
      } else {
        popupHide();
      }
    };

    window.addEventListener("scroll", handleScroll);

    onCleanup(() => {
      window.removeEventListener("scroll", handleScroll);
    });

    // onChange variant in section product
    const sectionProduct = builderMode
      ? document
      : document.querySelector(".veda-product-information-1") ||
        document.querySelector(".veda-product-information-2") ||
        document.querySelector(".veda-product-information-3") ||
        document.querySelector(".veda-product-information-4") ||
        document.querySelector(".veda-product-information-5");

    const inputSectionProductQuantity = sectionProduct.querySelector(
      'input[name="quantity"][form="product-add-cart"]'
    );
    const addonQuantity = container.querySelector(
      'input[name="quantity"][form="sticky-product-add-cart"]'
    );
    const addonPriceEle = container.querySelector(".product-price-on-sale-js");
    const addonPriceOnSale = addonPriceEle.querySelector("ins");
    const addonPriceNoteSale = addonPriceEle.querySelector("del");
    const addonProductId = container.querySelector(
      ".veda-product-variant-select-id-js"
    );
    const addonOptions = Array.from(
      container.querySelectorAll(".veda-sticky-option")
    );

    // counter
    if (!!inputSectionProductQuantity) {
      addonQuantity.value = inputSectionProductQuantity.value;
      addonQuantity.textContent = inputSectionProductQuantity.value;

      window.addEventListener("load", () => {
        addonQuantity.value = inputSectionProductQuantity.value;
        addonQuantity.textContent = inputSectionProductQuantity.value;
      });
    }

    veda.plugins.counter(container, {
      min: 1,
      max: Infinity,
      step: 1,
      value: 1,
      onChange: (value) => {
        // thay đổi quantity ở addon thì quantity ở section product thay đổi theo
        if (!!inputSectionProductQuantity) {
          inputSectionProductQuantity.value = value;
          inputSectionProductQuantity.textContent = value;
        }
      },
    });

    // Nếu tồn tại section product information mới hoạt động
    if (!!sectionProduct) {
      // Nếu có addon buy more save more thì set mặc định vào giá trên sticky
      const sectionPriceNotSale = sectionProduct.querySelector(
        ".price-not-sale.active"
      );
      const sectionPriceOnSale = sectionProduct.querySelector(
        ".price-on-sale.active span"
      );
      if (sectionPriceNotSale) {
        addonPriceNoteSale.textContent = sectionPriceNotSale.textContent.trim();
      }
      if (sectionPriceOnSale) {
        addonPriceOnSale.textContent = sectionPriceOnSale.textContent.trim();
      }

      // Lắng nghe thay đổi các node con trong node cha có class="veda-page-product-js". Bao gồm: giá tiền(giá gốc + giảm(nếu có)), variant id, số lượng sản phẩm
      const sectionProductForm = sectionProduct.querySelector(
        ".veda-page-product-js"
      );

      const sectionProductObserver = new MutationObserver((mutations) => {
        mutations.forEach((mutation) => {
          const target = mutation.target;

          // set variant id theo section product
          if (target.classList.contains("veda-product-variant-select-id-js")) {
            addonProductId.value = target.value;
          }

          // Sync quantity từ section product
          if (target.getAttribute("name") === "quantity") {
            addonQuantity.value = target.value;
            addonQuantity.textContent = target.value;
          }

          // Lắng nghe thay đổi select variant từ section để thay đổi text
          if (target.classList.contains("veda-toggle-group__item--active")) {
            const targetDataName = target.getAttribute("data-name");
            const targetDataValue = target.getAttribute("data-value");

            addonOptions.forEach((option) => {
              const dataNameOption = option.getAttribute("data-name");
              if (targetDataName === dataNameOption) {
                option.textContent = targetDataValue;
              }
            });
          }

          // Sync giá price từ section product
          if (
            target.classList.contains("product-price-on-sale-js") ||
            target.classList.contains("product-price-not-sale-js")
          ) {
            if (!target.classList.contains("d:none")) {
              if (target.classList.contains("product-price-on-sale-js")) {
                const insEle = target.querySelector("ins");
                const delEle = target.querySelector("del");
                addonPriceOnSale.textContent = insEle.textContent;
                addonPriceNoteSale.classList.remove("d:none");
                addonPriceNoteSale.textContent = delEle.textContent;
              }
              if (target.classList.contains("product-price-not-sale-js")) {
                addonPriceNoteSale.classList.add("d:none");
                addonPriceOnSale.textContent = target.textContent;
              }
            }
          }

          // Sync giá tiền từ addon buy more save more
          if (
            target.classList.contains("price-on-sale") &&
            target.classList.contains("active")
          ) {
            const content = target.querySelector("span");
            if (content) {
              addonPriceOnSale.textContent = content.textContent;
            } else {
              addonPriceOnSale.textContent = target.textContent.trim();
            }
          }

          if (
            target.classList.contains("price-not-sale") &&
            target.classList.contains("active")
          ) {
            addonPriceNoteSale.classList.remove("d:none");
            addonPriceNoteSale.textContent = target.textContent.trim();
          }
        });
      });

      sectionProductObserver.observe(sectionProductForm, {
        childList: true,
        attributes: true,
        subtree: true,
      });
      onCleanup(() => {
        sectionProductObserver.disconnect();
      });

      // handle add to cart
      const btnAddCart = container.querySelector(".product-card-add-js");

      const handleAddToCart = async () => {
        if (!loading) {
          loading = true;
          const spinner =
            "<div class='veda-spinner bdw:2px mr:10px d:block!' style='--spinner-color: var(--color-light-freeze); --spinner-size: 14px'></div>";
          btnAddCart.insertAdjacentHTML("afterbegin", spinner);

          if (builderMode) {
            setTimeout(() => {
              const currentSpinner = btnAddCart.querySelector(".veda-spinner");
              currentSpinner.remove();
              addCartSuccess(btnAddCart);
            }, 1000);
          } else {
            await cart
              .addToCart(
                Number(addonProductId.value.trim()),
                Number(addonQuantity.value)
              )
              .then(() => {
                const currentSpinner =
                  btnAddCart.querySelector(".veda-spinner");
                currentSpinner.remove();
                addCartSuccess(btnAddCart);
              })
              .catch((err) => {
                const currentSpinner =
                  btnAddCart.querySelector(".veda-spinner");
                currentSpinner.remove();
                loading = false;
                message.error(err.toString());
              });
          }
        }
      };

      btnAddCart.addEventListener("click", handleAddToCart);

      onCleanup(() => {
        btnAddCart.removeEventListener("click", handleAddToCart);
      });

      // handle scroll to section product
      const btnScroll = container.querySelector(".sticky-reselect");
      if (btnScroll) {
        const handleScrollToSection = () => {
          if (sectionProductForm) {
            sectionProductForm.scrollIntoView({ behavior: "smooth" });
          }
        };

        btnScroll.addEventListener("click", handleScrollToSection);

        onCleanup(() => {
          btnScroll.removeEventListener("click", handleScrollToSection);
        });
      }

      handleChangeBottom();
      handleHideOnMobile();

      window.addEventListener("resize", handleChangeBottom);
      window.addEventListener("resize", handleHideOnMobile);

      onCleanup(() => {
        window.removeEventListener("resize", handleChangeBottom);
        window.removeEventListener("resize", handleHideOnMobile);
      });
    }
  };
  main();
} else {
  container.style.display = "none";
}

        /* _____End/Content_____ */
      });
    } catch (error) {
      console.log(error);
    }
  };
veda_fn_id_00beb217344d416abf30dd8276f9dd97();
